import React from 'react';

export default function OAuthApps() {
  return <div><p>Superadmin OAuth Apps - coming soon</p></div>;
}
